<template>
  <transition name="fade">
    <div class="container">
      <h1>Profil</h1>
      <ProfileInfo
        :user="user"
        :beers="beers">
      </ProfileInfo>
      <div v-for="beer in user.drinkedBeers" :key="beer.id">
          <router-link :to="{ name: 'øl', params: { beer: beer }}">
            <Beer
              :beer="beer"
            ></Beer>
          </router-link>
      </div>

    </div>
  </transition>
</template>

<script>

import ProfileInfo from '../components/ProfileInfo.vue';
import Beer from '../components/Beer.vue';

export default {
  name: 'Profil',
  props: {
    beers: Array,
    user: Object
  },
  data: function() {
    function buildThresholdList(num) {
       let thresholds = [];
       let numSteps = num;

       for (let i=1.0; i<=numSteps; i++) {
         let ratio = i/numSteps;
         thresholds.push(ratio);
       }

       thresholds.push(0);
       return thresholds;
     }
    return {
      // localuser:  JSON.parse(JSON.stringify(this.user)),

      observer: null,
      lazyImages: [],
      options: {
        root: null,
        rootMargin: '110px',
        threshold: buildThresholdList(50)
      },
    }
  },
  components: {
    ProfileInfo,
    Beer
  },
  methods: {
    // updateUser: function(user) {
    //   axios.get('https://klogtkryds.dk/studenterbaren/api/drinkedBeersFromNickName/'+user)
    //     .then(res => {
    //       this.localuser.drinkedBeers = res.data.data;
    //       if(res.data.data.length < 1){
    //         this.localuser.id = 0;
    //         this.localuser.nickname = 'Ingen bruger med det navn har drukket øl hos Studenterbaren endnu';
    //       }else{
    //         this.localuser.id = res.data.data[0].user_id;
    //         this.localuser.nickname = res.data.data[0].nickname;
    //       }
    //     })
    //     .catch( () => {this.localuser.drinkedBeers = []});
    //   this.localuser = JSON.parse(JSON.stringify(this.localuser));
    // },
  },
  watch: {
    // localuser: function(){
    //   setTimeout(() => {
    //     this.lazyImages = this.$el.querySelectorAll('.beer img');
    //     this.lazyImages.forEach(img => {
    //       this.observer.observe(img);
    //     });
    //   }, 100);
    // }
  },
  mounted(){
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          this.observer.unobserve(lazyImage);
        }
      });
    }, this.options);
    this.lazyImages = this.$el.querySelectorAll('.beer img');

    this.lazyImages.forEach(img => {
      this.observer.observe(img);
    });
  },
  destroyed() {
    this.observer.disconnect();
  },
}

</script>

<style scoped>
  a{
    text-decoration: inherit;
    color: inherit;
  }
</style>
